import { render, staticRenderFns } from "./CustomersAutoComplete.vue?vue&type=template&id=bf3deaba"
import script from "./CustomersAutoComplete.vue?vue&type=script&lang=js"
export * from "./CustomersAutoComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports